import { render, staticRenderFns } from "./Alibaba-shop.vue?vue&type=template&id=47d762af&"
import script from "./Alibaba-shop.vue?vue&type=script&lang=js&"
export * from "./Alibaba-shop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports